export const cancelButtonStyle = {
    colorScheme: 'red',
    variant: 'ghost',
};